import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import {
    AdmonitionDirectiveDescriptor,
    BlockTypeSelect,
    BoldItalicUnderlineToggles,
    directivesPlugin,
    headingsPlugin,
    InsertTable,
    listsPlugin,
    ListsToggle,
    markdownShortcutPlugin,
    MDXEditor,
    quotePlugin,
    Separator,
    tablePlugin,
    toolbarPlugin,
    UndoRedo
} from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import {Stack, TextField} from "@mui/material";
import StyledModal from "../../Component/StyledModal";
import DateRange from "../../Component/DateRange";
import TimeFlatpicker from "../../Component/TimeFlatpicker";
import StyledSelect from "../../Component/StyledSelect";
import dbDate from "../../Utilities/dbDate";
import dbTime from "../../Utilities/dbTime";

function AddCamp(props) {
    const [user] = useContext(AuthContext);
    const [title, setTitle] = useState('');
    const [markdown, setMarkdown] = useState('');
    const [post, setPost] = useState('');
    const [when, setWhen] = useState(null);
    const [register, setRegister] = useState(null);
    const [registerTimeStart, setRegisterTimeStart] = useState('10:00');
    const [registerTimeEnd, setRegisterTimeEnd] = useState('18:00');
    const [participants, setParticipants] = useState(0);

    const [organizers, setOrganizers] = useState([]);
    const [seasons, setSeasons] = useState([]);
    const [types, setTypes] = useState([]);

    const [organizer, setOrganizer] = useState(null);
    const [season, setSeason] = useState(null);
    const [type, setType] = useState(null);


    useEffect(() => {
        setTitle('');
        setMarkdown('');
        setPost('');
        const abortController = new AbortController();
        async function fetchSeasons() {
            await fetch(`/api/season`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setSeasons(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        async function fetchOrganizers() {
            await fetch(`/api/organizer`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setOrganizers(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        async function fetchTypes() {
            await fetch(`/api/camp/type`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setTypes(data.map(item => {return {id: item.id, name: item.type}}));
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchSeasons();
        fetchOrganizers();
        fetchTypes();
        return () => abortController.abort();
    }, [props.data, user.token])

    function _send() {
        const formData = {
            camp: title,
            description: markdown,
            start_date: dbDate(when[0]),
            end_date: dbDate(when[1]),
            register_start: dbDate(register[0]),
            register_end: dbDate(register[1]),
            register_start_time: dbTime(registerTimeStart),
            register_end_time: dbTime(registerTimeEnd),
            participants: participants,
            type_id: type?.id,
            organizer_id: organizer?.id,
            season_id: season?.id,
            post_message: post
        };
        fetch(`/api/camp`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess();
                props.dismiss();
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <StyledModal isOpen={props.data !== false} title={'Dodaj Wydarzenie'} description={''} send={_send}
                     dismiss={props.dismiss}
                     actionLabel='Dodaj' fullWidth={true} maxWidth={'lg'}>
            <DateRange value={when} onChange={setWhen} label={'Kiedy'} />
            <StyledSelect
                name='organizer'
                label='Organizator'
                value={organizer}
                onChange={(e, v) => setOrganizer(v)}
                items={organizers}
            />
            <StyledSelect
                name='type'
                label='Typ'
                value={type}
                onChange={(e, v) => setType(v)}
                items={types}
            />
            <StyledSelect
                name='season'
                label='Sezon'
                value={season}
                onChange={(e, v) => setSeason(v)}
                items={seasons}
            />
            <TextField
                onChange={(e) => setTitle(e.target.value)}
                value={title}
                label='Tytuł'
                fullWidth
            />
            <MDXEditor
                markdown={markdown}
                onChange={setMarkdown}
                plugins={[
                    directivesPlugin({directiveDescriptors: [AdmonitionDirectiveDescriptor]}),
                    headingsPlugin(),
                    quotePlugin(),
                    listsPlugin(),
                    tablePlugin(),
                    markdownShortcutPlugin(),
                    toolbarPlugin({
                        toolbarClassName: 'my-classname',
                        toolbarContents: () => (
                            <>
                                {' '}
                                <UndoRedo/>
                                <Separator/>
                                <BoldItalicUnderlineToggles/>
                                <BlockTypeSelect/>
                                <ListsToggle/>
                                <InsertTable/>
                            </>
                        )
                    })
                ]}
            />
            <Stack direction={'row'}>
                <DateRange value={register} onChange={setRegister} label={'Zapisy'} />
            </Stack>
            <Stack direction={'row'}>
                <TimeFlatpicker value={registerTimeStart} onChange={setRegisterTimeStart} label={'Zapisy od godziny:'} />
                <TimeFlatpicker value={registerTimeEnd} onChange={setRegisterTimeEnd} label={'Zapisy do godziny:'} />
            </Stack>
            <TextField type={'number'} value={participants} onChange={(e) => setParticipants(e.target.value)} label={'Uczestników'}/>
            <TextField
                onChange={(e) => setPost(e.target.value)}
                value={post}
                label='Wiadomość po zapisie'
                fullWidth
            />
        </StyledModal>
    );
}

///* <hr />
//             <Markdown className="announcement" remarkPlugins={[remarkGfm]} remarkRehypeOptions={{ passThrough: ['u'] }}>{markdown}</Markdown>
export default AddCamp;